import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { API_URL } from "../../../shared/components/Widget/config/api";
import { thousandize } from "../../../../util/formatting";
import styles from "./FundraiserVippsNumberDisplay.module.scss";
export const FundraiserVippsNumberDisplay: React.FC<{
  fundraiserId: string;
  vippsNumber: string;
}> = t0 => {
  const $ = _c(13);
  const {
    vippsNumber,
    fundraiserId
  } = t0;
  const [sum, setSum] = useState(null);
  let t1;
  let t2;
  if ($[0] !== fundraiserId) {
    t1 = () => {
      fetch(`${API_URL}/fundraisers/${fundraiserId}/vippsnumber`).then(_temp).then(data => {
        setSum(data.content);
      });
    };
    t2 = [fundraiserId];
    $[0] = fundraiserId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!sum) {
    return null;
  }
  let t3;
  if ($[3] !== sum) {
    t3 = thousandize(sum);
    $[3] = sum;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `+ ${t3} kr i gaver til vippsnummer `;
  let t5;
  if ($[5] !== vippsNumber) {
    t5 = <span className={styles.number}>#{vippsNumber}</span>;
    $[5] = vippsNumber;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div className={styles.sum}>{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className={styles.context}>Gaver til vippsnummer oppdateres én gang i døgnet</div>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6) {
    t8 = <div className={styles.container}>{t6}{t7}</div>;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};
function _temp(res) {
  return res.json();
}